<script></script>

<template>
  <div class="tickets">
    <div class="tickets__text">{{ $t('ramadan.checkout.total') }}</div>
    <div class="tickets__label">
      <img src="@/shared/assets/images/ticket.svg" />
      <span>4</span>
    </div>
  </div>
</template>

<style scoped lang="scss">
  @import './TicketBlock';
</style>
